import React, {Component} from 'react';
import {Alert, Button, Col, Container, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import ReactLoadingTop from '../../../components/ReactLoadingTop';
import ReactErrorTop from '../../../components/ReactErrorTop';
import SignatureDetailViewer from './SignatureDetailViewer';
import {request} from "../../../helper/APIUtils";
import Axios from 'axios'
import HsmErrorAlert from '../../../common/hsm/HsmErrorAlert'
import SweetAlert from 'react-bootstrap-sweetalert';
import base64_arraybuffer from "base64-arraybuffer";

class DocumentSignatureValidator extends Component {

  constructor() {
    super();

    this.load = this.load.bind(this);
    this.newParams = this.newParams.bind(this);
    this.saveCertificateClicked = this.saveCertificateClicked.bind(this);
    this.showCertificateClicked = this.showCertificateClicked.bind(this);
    this.downloadLinkRef = React.createRef();

    this.state = {
      loading: false,
      result: null,
      loadedValue: null,
      alert: null
    };

    this.axios = Axios.create({
      baseURL: "http://127.0.0.1:9999"
    });
  }

  componentDidMount() {
    if (this.props.value && this.props.isOpen)
      this.load();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (prevProps.value){
      if (this.props.isOpen) {
        if (this.state.loadedValue !== this.props.value) {
          this.load();
        }
      }
    } else {
      if (this.result) {
        this.setState({
          result: null,
          loadedValue: null
        })
      }
    }
  }

  saveCertificateClicked(certificate) {
    let blob = new Blob( [ base64_arraybuffer.decode(certificate.value) ], { type: "application/pkix-cert" } );
    let urlCreator = window.URL || window.webkitURL;
    var url = urlCreator.createObjectURL(blob);
    this.setState({
      fileUrl: url,
      fileName: certificate.serial + ".cer"
    }, () => {
      this.downloadLinkRef.current.click();
      urlCreator.revokeObjectURL(url);
    });
  }

  showCertificateClicked(certificate) {
    this.axios.post("/certificate/show", {
      certificate: certificate.value
    })
      .then((response) => {
        this.setState({
          alert: (
            <SweetAlert success
                        confirmBtnText="Tamam"
                        confirmBtnBsStyle="success"
                        title="Başarılı"
                        onConfirm={() => this.setState({alert: null})}
            >
              Sertifika gösterildi. Görev çubuğundan sertifika üzerine tıklayınız.
            </SweetAlert>
          )
        });
      })
      .catch((error) => {

        this.setState({
          alert: <HsmErrorAlert error={error} onConfirm={() => this.setState({alert: null})} />
        });
      })
      .finally(() => {
        this.setState({loading: false});
      });
  }

  load() {

    this.setState({
      loadedValue: this.props.value,
      loading: true
    });
    request(this.newParams())
      .then((response => {
        this.setState({
          result: response.data
        });
      }))
      .catch()
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  newParams() {

    let param = {
      method: 'post',
      data: {
        document: base64_arraybuffer.encode(this.props.value.content)
      }
    }

    if (this.props.value.contentType === "application/xml")
      param.url = "/signature/helper/validateAndGetCertificate";
    else if (this.props.value.contentType === "application/pdf")
      param.url = "/signature/helper/validateAndGetCertificatePdf";
    else
      throw Error("Invalid content type");

    return param;
  }

  renderCertificateList() {
    return <div style={{marginLeft: "10px", marginRight:"10px"}}>
      <h4>Sertifikalar</h4>
      {
        this.state.result.certificateList.map(value => {
          return <Container>
            {this.props.value &&
                <Row>
                  <Col sm={12} md={4}>
                    <label>Dosya Adı</label>
                  </Col>
                  <Col sm={12} md={8}>
                    {this.props.value && this.props.value.fileName}
                  </Col>
                </Row>
            }
            <Row>
              <Col sm={12} md={4}>
                <label>Ortak ad</label>
              </Col>
              <Col sm={12} md={8}>
                {value.commonName}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={4}>
                <label>Seri no</label>
              </Col>
              <Col sm={12} md={8}>
                {value.serial}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={4}>
                <label>İmza Otoritesi</label>
              </Col>
              <Col sm={12} md={8}>
                {value.issuer}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={4}>
                <label>Geçerlilik baslangıcı</label>
              </Col>
              <Col sm={12} md={8}>
                {value.validFrom}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={4}>
                <label>Geçerlilik sonu</label>
              </Col>
              <Col sm={12} md={8}>
                {value.expiresOn}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={4}>
                <label>İmzalama zamanı</label>
              </Col>
              <Col sm={12} md={8}>
                {value.singingTime}
              </Col>
            </Row>
            {value.validationResult && <Row>
              <Col sm={12}>
                <SignatureDetailViewer value={value.validationResult} hideText="Sertifika dorğrulama ayrıntılarını gizle" showText="Sertifika dorğrulama ayrıntılarını göster"/>
              </Col>
            </Row>}
            <Row>
              <Col sm={12} md={6}>
              </Col>
              <Col sm={12} md={3}>
                <Button style={{width: '100%'}} color="primary" onClick={() => this.saveCertificateClicked(value)}>
                  Sertifikayı kaydet
                </Button>
              </Col>
              <Col sm={12} md={3}>
                <Button  style={{width: '100%'}} color="secondary" onClick={() => this.showCertificateClicked(value)}>
                  Sertifikayı göster
                </Button>
              </Col>
            </Row>
          </Container>
        })
      }
    </div>
  }

  renderError() {
    return <Alert color="danger" style={{marginBottom: "0px"}}>
      {this.state.result.error || "İmza doğrulanamadı"}
    </Alert>
  }

  renderSuccess() {
    return <Alert color="success" style={{marginBottom: "0px"}}>
      İmza başarıyla doğrulandı
    </Alert>
  }

  render() {
    return <Modal isOpen={this.props.isOpen} size="lg" >
      <ModalHeader className="justify-content-center" toggle={this.props.toggle}>
        {this.props.value && this.props.value.name}
      </ModalHeader>
      <ModalBody style={{padding: "0", height: "500px", overflowY: "scroll"}}>
        {this.state.loading && <ReactLoadingTop style={{width:"200px", height: "200px"}}/>}
        {!this.state.loading && !this.state.result && <ReactErrorTop style={{width:"200px", height: "200px"}}/>}
        {!this.state.loading && this.state.result && !this.state.result.valid && this.renderError()}
        {!this.state.loading && this.state.result && this.state.result.valid && this.renderSuccess()}
        {!this.state.loading && this.state.result && this.state.result.detailedMessage && <SignatureDetailViewer value={this.state.result.detailedMessage} hideText="İmza doğrulama ayrıntılarını gizle" showText="İmza doğrulama ayrıntılarını göster"/>}
        {!this.state.loading && this.state.result && this.state.result.certificateList && this.state.result.certificateList.length > 0 && this.renderCertificateList()}
      </ModalBody>
      <a ref={this.downloadLinkRef} style={{display: 'none'}} href={this.state.fileUrl} download={this.state.fileName}/>
      {this.state.alert}
    </Modal>
  }
}

export default DocumentSignatureValidator;
